import { render, staticRenderFns } from "./EmployeeMonthSeniority.vue?vue&type=template&id=22d6b0d2&scoped=true&"
import script from "./EmployeeMonthSeniority.vue?vue&type=script&lang=js&"
export * from "./EmployeeMonthSeniority.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeMonthSeniority.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EmployeeMonthSeniority.vue?vue&type=style&index=1&id=22d6b0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d6b0d2",
  null
  
)

export default component.exports